module.exports = __webpack_public_path__ + "static/media/casi_lo_logras_1.32f3ee9b.png";